// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2024project/q3/2024technology/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (workType: number, page: number, search: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      workType,
      page,
      search,
    },
  });
};

const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const getRules = (id: number) => {
  const data: { [key: number]: string } = {
    1: `<p>为深入学习贯彻党的二十届三中全会精神，全面贯彻习近平总书记关于科技创新的重要论述和视察重庆重要讲话重要指示精神，落实全国科技大会精神，深入实施科技创新和人才强市首位战略，奋力打造具有全国影响力的科技创新中心，重庆日报报业集团创新开展2024重庆科创向上主题宣传活动。通过挖掘、宣传一批对推动重庆科技创新高质量发展做出贡献、取得优异成绩的榜样人才及成果，以示范引领作用激发科技创新内在动力，增强人才创新协同活力，构建科技开放创新生态。</p>`,
    2: `<h4>主办单位</h4>
<p>重庆日报报业集团</p>
<h4>支持单位</h4>
<p>西部科学城重庆高新区管委会</p>
<h4>承办单位</h4>
<p>上游新闻</p>
<h4>数据支持单位</h4>
<p>天眼查</p>
<h4>协办单位</h4>
<p>重庆高新区科协</p>`,
    3: `<p><span style='font-weight:600'>一、重庆科技创新年度人物</span></p>
<p><span style='font-weight:600'>二、重庆科技创新年度企业家</span></p>
<p><span style='font-weight:600'>三、西部（重庆）科学城科技创新成果</span></p>`,
    4: `<p>&nbsp;&nbsp;<span style='font-weight:600'>（一）重庆科技创新年度人物</span></p>
        <p>&nbsp;&nbsp;包括专业技术人才、高技能人才、科研工作者、企业科技管理人才等。</p>
        <p>&nbsp;&nbsp;1.坚持正确政治方向，热爱祖国，自觉践行社会主义核心价值观。</p>
<p>&nbsp;&nbsp;2.遵守宪法和法律。</p>
<p>&nbsp;&nbsp;3.具有良好的职业道德，诚实守信、爱岗敬业、学风严谨、为人正派，在本领域（行业）具有良好声誉，本人及所在单位近三年没有重大违规违法行为。</p>
<p>&nbsp;&nbsp;4.原则上须于2024年度在同一单位相关岗位工作任职，特殊情况可适当放宽。</p>
<p>&nbsp;&nbsp;5.所在单位注册地为重庆，注册时间原则上应满2年，特殊情况可适当放宽。</p>
<p>&nbsp;&nbsp;6.须在2024年度对推动科技领域创新发展做出重大贡献，形成社会影响力，符合下列条件之一：</p>
<p>（1）重大科学研究引领。带领重要科学技术研究，引领科技创新项目的研发取得一定突破，为社会发展的关键科学问题提供较好的解决方案。</p>
<p>（2）科技创新成果突破。重视科技创新，通过对技术产品的开发、应用、推广，实现关键技术突破或取得重大研究成果，促进科学技术的对外开放与应用合作。</p>
<p>（3）科创成果转移转化。科学创新技术成果实现转移转化，将转化成果推广到市场并产生较好的市场效益，促进提高科技成果转化和产业化水平。</p>
<p>（4）社会效应发展驱动。科技创新所取得成果为社会公共服务提供较高质量科普产品并产生积极社会效应。</p>
<p>&nbsp;&nbsp;<span style='font-weight:600'>（二）重庆科技创新年度企业家</span></p>
<p>&nbsp;&nbsp;为企业主要经营管理者，即董事长、总裁或总经理等主持工作的实际负责人。</p>
<p>&nbsp;&nbsp;1.坚持正确政治方向，热爱祖国，自觉践行社会主义核心价值观。</p>
<p>&nbsp;&nbsp;2.遵守宪法和法律。</p>
<p>&nbsp;&nbsp;3.具有良好的职业道德，诚实守信、爱岗敬业、学风严谨、为人正派，在本领域（行业）具有良好声誉，本人及所在单位近三年没有重大违规违法行为。</p>
<p>&nbsp;&nbsp;4.原则上须于2024年度在同一单位担任董事长、总裁或总经理等主要领导职务，特殊情况可适当放宽。</p>
<p>&nbsp;&nbsp;5.所在单位注册地为重庆，注册时间原则上应满2年，特殊情况可适当放宽。</p>
<p>&nbsp;&nbsp;6.须在2024年度以科技创新带动企业发展，并发挥积极的行业引领作用，创造了突出的经济效益和社会效应，符合下列条件之一：</p>
<p>（1）经济表现优异。所在企业在行业中，拥有较为领先的市场地位、经济表现优异。</p>
<p>（2）核心技术攻关。所带领企业拥有较强的创新能力，在自主研发或推广新技术、促进产业融合等方面有新成果、新突破、新贡献。</p>
<p>（3）人才团队强劲。积极引进和培养科技创新领域专业人才，拥有一支强有力的科技创新人才队伍。</p>
<p>（4）公众影响深远。具有良好的公众影响力、知名度、诚信度，积极关注并支持社会公益事业建设。</p>
<p>&nbsp;&nbsp;<span style='font-weight:600'>（三）西部（重庆）科学城科技创新成果</span></p>
<p>&nbsp;&nbsp;1.参与主体所属权须为工商、税务注册登记在西部（重庆）科学城范围内的企业、高校、科研院所或其他实体机构，在本领域（行业）具有良好声誉，近三年没有严重违法违规行为。</p>
<p>&nbsp;&nbsp;2.充分聚焦西部（重庆）科学城现代制造业集群体系建设，重点围绕智能网联新能源汽车及核心器件、软件和信息服务、新型智能终端3个主导产业，集成电路、生物医药2个特色优势产业，新能源及新型储能、空天信息、AI及机器人3个未来产业，汽车电子、功率半导体及化合物半导体、模拟及数模混合集成电路特色工艺、数字医疗和医疗器械、智能装备制造、前沿新材料、工业设计及数字文创、检验检测8个高成长性细分产业开展科技创新。</p>
<p>&nbsp;&nbsp;3.研发方向、技术成果和创新产品在科技创新领域获得突破性成果，在全市、全国乃至国际上有重大影响，对西部（重庆）科学城的科技创新、产业发展和经济增长起到积极的支撑和推动作用，且符合下列条件之一：</p>
<p>（1）创新成果突出。具有突破关键“卡脖子”技术的研究成果或科技创新成果成功转移转化，在前沿科技研发创新方面具有较强的行业牵引性和示范性。</p>
<p>（2）知识产权明晰。具有核心知识产权，无知识产权纠纷。基础研究具备原创性、探索性和创新性。其中，原创性的研究成果转化为原创性的技术，为科技进步和产业转型升级提供核心动力和技术支撑。</p>
<p>（3）高端人才领衔。所属团队拥有多名科技创新领域的高层次人才或领军人才，研发能力强，合作协同度高。</p>
<p>（4）市场前景广阔。研发成果已投入或即将投入市场，应用场景广泛，商业模式创新，具备一定的市场发展潜力或已产生较为显著的经济效益。</p>`,
    5: `<h4>报名表下载：</h4>
    <p><a download="重庆科技创新年度人物报名表" href="https://image2.cqcb.com/d/file/topics/activity/2024-11-29/0s8pt51s-1732850771036.docx">
    重庆科技创新年度人物报名表
    </a></p>
    <p><a download="重庆科技创新年度企业家报名表" href="https://image2.cqcb.com/d/file/topics/activity/2024-11-29/bPVPlqDZ-1732850886393.docx">
    重庆科技创新年度企业家报名表
    </a></p>
    <p><a download="西部（重庆）科学城科技创新成果报名表" href="https://image2.cqcb.com/d/file/topics/activity/2024-11-29/4DToNnob-1732850906717.docx">
    西部（重庆）科学城科技创新成果报名表
    </a></p>
    <h4>报名咨询电话：</h4>
    <p>王老师15123398085（微信同号）</p>
    <h4>报名材料上传邮箱：</h4>
    <p>kcrw2024@163.com</p>    
    <h4>报名截至：</h4>
    <p>2024年11月8日</p>`,
  };
  return data[id];
};
export { getBaseInfo, getVoteList, getDetail, getRules, getNews };
